import React from 'react';
export function ValueCTA() {
  return <section className="w-full bg-white px-4 md:px-8 pb-16" data-id="element-368">
      <div className="max-w-[700px] mx-auto" data-id="element-369">
        {/* Dashed Red Border Box */}
        <div className="rounded-2xl px-6 py-8 md:px-10 md:py-10 text-center mb-8" style={{
        border: '3px dashed #c0392b'
      }} data-id="element-370">
          {/* Premium Module */}
          <div className="mb-6 text-left bg-[#f0faf0] rounded-xl p-5 md:p-6 border border-[#4caf50]/30" data-id="element-371">
            <p className="font-['Montserrat',_sans-serif] text-[#2d6a2e] font-bold text-base md:text-lg mb-3" data-id="element-372">
              🎁 Y además, solo por hoy, te llevás el Módulo Premium:
            </p>
            <p className="font-['Montserrat',_sans-serif] text-[#1a1a1a] text-sm md:text-base mb-3" data-id="element-373">
              🚀 <span className="font-bold" data-id="element-374">Cómo usar PedidosYa y Rappi</span>{' '}
              para escalar cuando ya estés vendiendo.
            </p>
            <p className="font-['Montserrat',_sans-serif] text-[#1a1a1a] text-sm md:text-base" data-id="element-375">
              📹 Con <span className="font-bold" data-id="element-376">2 módulos extras</span> y{' '}
              <span className="font-bold" data-id="element-377">2 videos explicativos</span> paso a
              paso para{' '}
              <span className="font-bold uppercase" data-id="element-378">
                vender en gran volumen
              </span>
              .
            </p>
          </div>

          {/* Title */}
          <p className="font-['Playfair_Display',_serif] text-[#2d6a2e] text-xl md:text-2xl font-bold underline underline-offset-4 decoration-2 mb-5 uppercase" data-id="element-379">
            El valor real es incalculable...
          </p>

          {/* Green Pill */}
          <div className="inline-block bg-[#4caf50] rounded-lg py-2.5 px-5 md:px-8 mb-5" data-id="element-380">
            <p className="font-['Montserrat',_sans-serif] text-white font-bold text-sm md:text-base" data-id="element-381">
              Te llevás el Sistema Completo + KitPro +<br data-id="element-382" />
              10 Negocios en 1.
            </p>
          </div>

          {/* Price */}
          <div className="flex items-center justify-center gap-3 mb-3 flex-wrap" data-id="element-383">
            <span className="font-['Montserrat',_sans-serif] line-through text-[#c0392b] font-bold text-2xl md:text-3xl" data-id="element-384">
              $554.000
            </span>
            <span className="font-['Montserrat',_sans-serif] bg-[#1e2330] text-white font-bold text-sm md:text-base px-4 py-1.5 rounded-lg uppercase" data-id="element-385">
              Solo por hoy
            </span>
          </div>

          {/* Free text */}
          <p className="font-['Montserrat',_sans-serif] text-[#4caf50] font-bold text-lg md:text-xl" data-id="element-386">
            GRATIS con tu compra
          </p>
        </div>

        {/* CTA Button */}
        <a href="https://cocinaydulcesrentables.com/cart/54079778619676:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-[#4caf50] hover:bg-[#43a047] text-white font-['Montserrat',_sans-serif] font-bold text-lg md:text-xl uppercase py-4 md:py-5 rounded-full transition-colors shadow-[0_4px_16px_rgba(76,175,80,0.4)] text-center" data-id="element-387">
          ¡ASEGURAR MIS BONOS AHORA!
        </a>
      </div>
    </section>;
}